(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/services/account-balance.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/services/account-balance.js');
"use strict";


const {
  account_balance
} = svs.components;
let balance;

svs.sportsbook.sbtech_api_impl.services.accountBalance = function () {
  let callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => {};
  let forceUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (forceUpdate || typeof balance === 'undefined') {
    account_balance.get(forceUpdate, (accountBalance, err) => callback(accountBalance, err) || (balance = accountBalance));
  } else {
    callback(balance);
  }
};

 })(window);